import API from '../interceptors/Api';

const baseRoute = '/user-workspaces';

export const getUserWorkspaces = (params) => API.get(baseRoute, { params });

export const getUserWorkspacesViews = (params) => API.get(`${baseRoute}/views`, { params });

export const getUserWorkspacesByClient = (params?) => API.get(`${baseRoute}/client`, { params });

export const getUserWorkspaceDetails = (id, params: Record<string, any> = {}) => API.get(`${baseRoute}/${id}`, { params });

export const setDefaultUserWorkspace = (id) => API.put(`${baseRoute}/${id}/default`);

export const unSubscribeUserWorkspace = (workspaceId) => API.delete(`${baseRoute}/${workspaceId}`);

export const subscribeUserWorkspace = (workspaceId) => API.post(`${baseRoute}/${workspaceId}`);

export const inviteUserWorkspace = (workspaceId, data) => API.post(`${baseRoute}/${workspaceId}/users`, data);

export const editUserWorkspace = (
  workspaceId,
  { userId, role },
) => API.put(`${baseRoute}/${workspaceId}/users/${userId}/roles/${role}`);

export const deleteUserWorkspace = (workspaceId, userId) => API.delete(`${baseRoute}/${workspaceId}/users/${userId}`);

export const resendInvitationUserWorkspace = (workspaceId, { userId, channel }) => API.post(`${baseRoute}/${workspaceId}/users/${userId}/resend`, { channel });

export const addUserToWorkspace = (workspaceId, data) => API.post(`${baseRoute}/${workspaceId}/users`, data, {
  headers: { 'X-Workspace-Id': workspaceId, 'X-Workspace-View-Id': false },
});
